var _g;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgCorner = function SvgCorner(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11898",
    "data-name": "Group 11898",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1117",
    "data-name": "Rectangle 1117",
    width: 1,
    height: 10,
    rx: 0.5,
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1118",
    "data-name": "Rectangle 1118",
    width: 10,
    height: 1,
    rx: 0.5,
    transform: "translate(0 9)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Intersection_1",
    "data-name": "Intersection 1",
    transform: "translate(0 5)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,5V0A5,5,0,0,1,5,5Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3.873459815979004 4 C 3.510890245437622 2.596415519714355 2.403584480285645 1.489109635353088 1 1.126540184020996 L 1 4 L 3.873459815979004 4 M 5 5 L 0 5 L 0 0 C 2.760740041732788 0 5 2.238280057907104 5 5 Z",
    stroke: "none",
    fill: "#fff"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCorner, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMCIgaGVpZ2h0PSIxMCIgdmlld0JveD0iMCAwIDEwIDEwIj4KICA8ZyBpZD0iR3JvdXBfMTE4OTgiIGRhdGEtbmFtZT0iR3JvdXAgMTE4OTgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDApIj4KICAgIDxyZWN0IGlkPSJSZWN0YW5nbGVfMTExNyIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgMTExNyIgd2lkdGg9IjEiIGhlaWdodD0iMTAiIHJ4PSIwLjUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDApIiBmaWxsPSIjZmZmIi8+CiAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlXzExMTgiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDExMTgiIHdpZHRoPSIxMCIgaGVpZ2h0PSIxIiByeD0iMC41IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDkpIiBmaWxsPSIjZmZmIi8+CiAgICA8ZyBpZD0iSW50ZXJzZWN0aW9uXzEiIGRhdGEtbmFtZT0iSW50ZXJzZWN0aW9uIDEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgNSkiIGZpbGw9Im5vbmUiPgogICAgICA8cGF0aCBkPSJNMCw1VjBBNSw1LDAsMCwxLDUsNVoiIHN0cm9rZT0ibm9uZSIvPgogICAgICA8cGF0aCBkPSJNIDMuODczNDU5ODE1OTc5MDA0IDQgQyAzLjUxMDg5MDI0NTQzNzYyMiAyLjU5NjQxNTUxOTcxNDM1NSAyLjQwMzU4NDQ4MDI4NTY0NSAxLjQ4OTEwOTYzNTM1MzA4OCAxIDEuMTI2NTQwMTg0MDIwOTk2IEwgMSA0IEwgMy44NzM0NTk4MTU5NzkwMDQgNCBNIDUgNSBMIDAgNSBMIDAgMCBDIDIuNzYwNzQwMDQxNzMyNzg4IDAgNSAyLjIzODI4MDA1NzkwNzEwNCA1IDUgWiIgc3Ryb2tlPSJub25lIiBmaWxsPSIjZmZmIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };